/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from 'react';
import { dayjs, Dayjs } from 'lib/dayjs';

export const NOT_CALCULATED = 'NC';

type RertDateContextType = {
  date: Dayjs;
  setDate: (date: Dayjs) => void;
};

export const RertDateContext = createContext<RertDateContextType>({
  date: dayjs(),
  setDate: () => {},
});

export const useRertDate = () => {
  return useContext(RertDateContext);
};
